export default {
  name: 'dashify:CondtionalIf',
  title: 'Condtional If Then Else When Unless',
  owner: 'System',
  solution: '',
  tags: ['html', 'list'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    age: 16,
    drinkingAge: 21,
    view: [
      [
        'div',
        {},
        [
          ['p', {}, '/${ "Age is " & age}'],
          [
            'button',
            {
              '.': 'bg-transparent min-w-[100px]  hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded',
              type: 'text',
              onClick: "/${ function() { $set('/age', age+1) } }",
            },
            '+',
          ],
          [
            'button',
            {
              '.': 'bg-transparent min-w-[100px] hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded',
              type: 'text',
              onClick: "/${ function() { $set('/age', age-1) } }",
            },
            '-',
          ],
        ],
      ],
      [
        'div',
        { '.': 'p-2 mt-2' },
        [
          [
            'dashify:If',
            { condition: '/${ age >= drinkingAge}' },
            [
              ['dashify:Then', {}, [['div', {}, 'You can drink']]],
              ['dashify:Else', {}, [['div', {}, 'You cannot drink']]],
            ],
          ],
          ['dashify:When', { condition: '/${ age > 18}' }, [['div', {}, 'You are an adult']]],
          ['dashify:Unless', { condition: '/${ age > 18}' }, [['div', {}, 'You are young']]],
        ],
      ],
    ],
  },
};
